package com.starparty.app.astro0.celestialobjects

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.SphericalCoords

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
abstract class CelestialBody : CelestialPoint {
    var abbrevName = ""
    var rgbColour = SP_Colour(150,150,150,255) // Grey Default

    constructor():super(){}

    constructor(ra: Double, dec: Double, name: String) : super(ra, dec) { this.name = name }

    protected abstract fun recalculateEquatorialCoordinates(time: SP_Time)

    fun setTime(t: SP_Time) {
        recalculateCartesianCoordinates(t)
    }

    /** Overrides to perform no action as this is performed by the
     * the recalculateCartesianCoordinates(Time) method   */
    override fun calculateCartesianCoordinates() {
    }

    fun recalculateCartesianCoordinates(t: SP_Time) {
        recalculateEquatorialCoordinates(t)
        val equ = equatorialCoords

        SphericalCoords.sphericalToCartesian(itsRA_Radians, itsDec_Radians, cartesianCoordinates)
    }
}